import { ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Organization } from '../../models/organization/organization.model';
import { UploadService } from '../../core/upload.service';
import { ErrorDialogService } from '../error-dialog/error-dialog.service';

@Component({
    selector: 'app-edit-organization-dialog',
    templateUrl: './edit-organization-dialog.component.html',
    styleUrls: ['./edit-organization-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EditOrganizationDialogComponent implements OnInit {
    transRatePercent = 0;
    overCostPercent = 0;

    muTransRatePercent = 0;
    salesCommissPercent = 0;

    // for logo
    apiKey: string;
    logoUrl;
    logoFileToUpload?: File;

    defaultReviewer = 'admin';

    constructor(
        public dialogRef: MatDialogRef<EditOrganizationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Partial<Organization> & { orgId: string },
        private uploadService: UploadService,
        private changeDetectorRef: ChangeDetectorRef,
        private errorDialog: ErrorDialogService
    ) { }

    ngOnInit(): void {
        if (this.data.logoUrl) {
            this.logoUrl = this.data.logoUrl;
        }

        if (this.data.isSelfServiceReview) {
            this.defaultReviewer = 'self';
        } else {
            this.defaultReviewer = 'admin';
        }

        if (this.data.buyRates?.ratePerTrans) {
            this.transRatePercent = Number((this.data.buyRates.ratePerTrans * 100).toFixed(5));
        }
        if (this.data.buyRates?.profitOverCost) {
            this.overCostPercent = Number((this.data.buyRates.profitOverCost * 100).toFixed(5));
        }

        if (this.data.defaultUserMarkup?.ratePerTrans) {
            this.muTransRatePercent = Number((this.data.defaultUserMarkup.ratePerTrans * 100).toFixed(5));
        }
        if (this.data.defaultSalesCommissionPercent) {
            this.salesCommissPercent = Number((this.data.defaultSalesCommissionPercent * 100).toFixed(5));
        }
        this.changeDetectorRef.detectChanges();
    }

    uploadLogo(files: FileList) {
        const newLogo = files[0];
        this.logoFileToUpload = newLogo;

        const reader = new FileReader();
        reader.onload = () => {
            this.logoUrl = reader.result as string;
            this.changeDetectorRef.detectChanges();
        };
        reader.readAsDataURL(newLogo);
    }

    save() {
        this.data.buyRates!.ratePerTrans = this.transRatePercent ? Number((this.transRatePercent / 100).toFixed(7)) : 0;
        this.data.buyRates!.profitOverCost = this.overCostPercent ? Number((this.overCostPercent / 100).toFixed(7)) : 0;

        this.data.defaultUserMarkup!.ratePerTrans = this.muTransRatePercent ? Number((this.muTransRatePercent / 100).toFixed(7)) : 0;
        this.data.defaultSalesCommissionPercent = this.salesCommissPercent ? Number((this.salesCommissPercent / 100).toFixed(7)) : 0;

        this.data.isSelfServiceReview = this.defaultReviewer === 'self';

        if (this.logoFileToUpload) {
            this.uploadService.addNewOrganizationLogo(this.data.orgId!, this.logoFileToUpload)
                .then((res: { logoUrl: string }) => {
                    this.data.logoUrl = res.logoUrl;
                    this.dialogRef.close({ ...this.data });
                })
                .catch(async err => {
                    this.errorDialog.open('Connection Error', 'Could not upload the provided logo.');
                })
                .finally(() => {
                    this.changeDetectorRef.detectChanges();
                });
        } else {
            this.data.logoUrl = this.logoUrl;
            this.dialogRef.close({ ...this.data });
            this.changeDetectorRef.detectChanges();
        }
    }

}
